module.exports = __webpack_public_path__ + "img/ninjacargo.19aa45c2.png";